import { render, staticRenderFns } from "./CustomerFullInfo.vue?vue&type=template&id=8cd2e392&scoped=true&"
import script from "./CustomerFullInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerFullInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFullInfo.vue?vue&type=style&index=0&id=8cd2e392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd2e392",
  null
  
)

export default component.exports